var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0881 0.703046C10.8873 0.273407 10.4631 0 9.99728 0C9.53142 0 9.11101 0.273407 8.90649 0.703046L6.47114 5.87044L1.03233 6.69847C0.577834 6.76877 0.199086 7.09686 0.05895 7.54603C-0.0811866 7.9952 0.0324375 8.49124 0.35816 8.82323L4.30471 12.8501L3.37299 18.5409C3.29724 19.0096 3.48661 19.4861 3.86157 19.7634C4.23653 20.0407 4.73269 20.0759 5.14174 19.8532L10.0011 17.1778L14.8604 19.8532C15.2694 20.0759 15.7656 20.0446 16.1406 19.7634C16.5155 19.4822 16.7049 19.0096 16.6291 18.5409L15.6936 12.8501L19.6402 8.82323C19.9659 8.49124 20.0833 7.9952 19.9394 7.54603C19.7955 7.09686 19.4205 6.76877 18.966 6.69847L13.5234 5.87044L11.0881 0.703046Z",
    fill: "#CB8D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.1dc765d811f3d342bab5c77a85debaaa.svg";
export { ForwardRef as ReactComponent };